import React from "react";
export default function NotFound(){
    return <div className={'d-flex flex-column justify-content-center align-items-center'}>
        <img src={'./404.png'} alt=""/>
        <p>صفحه مورد نظر یافت نشد.</p>
    </div>
}
